'use strict';

import _ from 'lodash';

import './index.less';

import React from 'react';
import classnames from 'classnames';
import { format } from 'date-fns';

import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import conversionFeedbackOptions from 'ck-core/source/data/conversionFeedbackOptions';
import isRecurringPlanDuration from 'ck-core/source/functions/isRecurringPlanDuration';
import planTypeToPlanId from 'ck-core/source/functions/planTypeToPlanId';
import langToReactElements from 'ck-core-client/source/functions/langToReactElements';
import WithCurrency from 'ck-website/source/ui/newPayments/WithCurrency.jsx';
import subscriptionPlans from 'ck-core/source/collections/subscriptionPlans';
import { VanillaPaymentPlans } from 'ck-website/source/ui/newPayments/PaymentPlans';
import { BILLING_METHOD, ConnectedPaymentForm } from 'ck-website/source/components/PaymentForm';
import TileChoice from 'ck-website/source/ui/TileChoice.jsx';
import TileChoices from 'ck-website/source/ui/TileChoices.jsx';
import Frame from 'ck-core-client/source/ui/Frame';
import {
	Props as PaymentSummaryTableProps,
	WHEN_REDEEMED
} from 'ck-website/source/components/PaymentSummaryTable';
import { DesktopPaymentSummary } from 'ck-website/source/components/PaymentSummary/Desktop';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import { lang } from './lang';
import verifyCouponFromClient from '../../functions/verifyCouponFromClient';
import StorageManager from 'ck-core-client/source/managers/StorageManager';
import storageAffiliateKey from '../../data/storageAffiliateKey';
import Language from 'ck-core/source/services/Language';
import Form from 'ck-core-client/source/ui/Form.jsx';
import TextInput from 'ck-core-client/source/ui/form/TextInput';
import TextAreaInput from 'ck-core-client/source/ui/form/TextAreaInput';
import CheckboxInput from 'ck-core-client/source/ui/form/CheckboxInput';
import PasswordVerifier from 'ck-core/source/verifiers/user/PasswordVerifier';
import ProgressIndicator from 'ck-core-client/source/ui/components/ProgressIndicator/ProgressIndicator.jsx';
import { Product, PRODUCT_ID, PRODUCTS } from 'ck-core/source/data/Product';
import { MobilePaymentSummary } from 'ck-website/source/components/PaymentSummary/Mobile';
import { PlanType } from 'ck-core/source/data/PlanType';
import { PLAN_SIZE } from 'ck-core/source/data/PlanSize';
import { CURRENCY } from 'ck-core/source/data/Currency';
import { PLAN_DURATION } from 'ck-core/source/data/PlanDuration';
import { InteractionProps as CheckboxBannerInteractionProps } from '../CheckboxBanner';
import { FRIENDLY } from 'ck-core/source/data/DateFormat';
import UserManager from 'ck-core-client/source/managers/UserManager';
import { MonetaryValue } from 'ck-core/source/classes/MonetaryValue';
import { HereToHelp } from 'ck-website/source/components/HereToHelp';
import IntercomManager from 'ck-core-client/source/managers/IntercomManager';

import minecraftImage from 'ck-core-web/graphics/generic/platform-modding.png';
import robloxImage from 'ck-core-web/graphics/generic/platform-roblox.png';
import bundleImage from 'ck-core-web/graphics/generic/platform-bundle.svg';
import checkoutConfirmationTick from 'ck-core-client/graphics/checkout/checkout-confirmation-tick.svg';
import individualImage from 'ck-core-client/graphics/checkout/checkout-flow-individual.svg';
import familyImage from 'ck-core-client/graphics/checkout/checkout-flow-family.svg';
import { withAppContext, AppContext } from 'ck-core-client/source/context';
import {
	FACEBOOK_STANDARD_EVENT,
	FACEBOOK_CUSTOM_EVENT
} from 'ck-core-client/source/trackers/Facebook';
import {
	TIKTOK_STANDARD_EVENT,
	TIKTOK_CUSTOM_EVENT
} from 'ck-core-client/source/trackers/TikTok';
import { ADWORDS_CONVERSION_LABEL } from 'ck-core-client/source/trackers/Adwords';
import { GuaranteesBanner } from '../GuaranteesBanner';

const PRODUCT_IMAGES: { [key in PRODUCT_ID]: string } = {
	[PRODUCT_ID.MINECRAFT]: minecraftImage,
	[PRODUCT_ID.ROBLOX]: robloxImage,
	[PRODUCT_ID.BUNDLE]: bundleImage
};

const SIZE_IMAGES: { [key in PLAN_SIZE]: string } = {
	[PLAN_SIZE.INDIVIDUAL]: individualImage,
	[PLAN_SIZE.FAMILY]: familyImage
};

export enum STAGE {
	PRODUCT = 'product',
	SIZE = 'size',
	DURATION = 'duration',
	PAYMENT = 'payment',
	CONFIRMATION = 'confirmation'
}

enum STAGE_WITH_CHOICE {
	PRODUCT = 'product',
	SIZE = 'size',
	DURATION = 'duration'
}

export enum CHECKOUT_THEME {
	SIDEBAR = 'sidebar',
	COMPACT = 'compact'
}

const STAGE_LIST = [STAGE.PRODUCT, STAGE.SIZE, STAGE.DURATION, STAGE.PAYMENT, STAGE.CONFIRMATION];

export interface PaymentSummaryProps extends PaymentSummaryTableProps {
	isSubscriptionChange: boolean;
	moneyBackGuarantee?: string;
	product: Product;
	intervalDescription: string;
	showCancelAnytime: boolean;
}

export interface Choices {
	[STAGE.PRODUCT]?: PRODUCT_ID;
	[STAGE.SIZE]?: PLAN_SIZE;
	[STAGE.DURATION]?: PLAN_DURATION;
}

export interface Props {
	appContext: AppContext;
	currency: CURRENCY;
	allowCurrencyChange: boolean;
	handleCurrencyChange: (currency: CURRENCY) => void;
	choices: Choices;
	currentPlanType?: PlanType;
	planTypes: PlanType[];

	allowStageNavigation: boolean;
	showGuaranteesBanner: boolean;
	showGiftCheckbox: boolean;
	showFamilyCheckbox: boolean;
	theme?: CHECKOUT_THEME;

	handleSelectPlan?: (planId: string) => void;
}

export interface State {
	planId?: string;
	coupon?: any;
	stage: STAGE;
	choices: Choices;
	giftCheckboxBanner?: CheckboxBannerInteractionProps;

	purchaseId?: string;
	hadAPlan?: boolean;
	paymentEmail?: string;
}

export class CheckoutStages extends React.Component<Props, State> {
	feedbackForm?: Form;

	static defaultProps = {
		allowStageNavigation: true,
		showGiftCheckbox: true,
		showFamilyCheckbox: true,
		choices: {}
	};

	constructor(props: Props) {
		super(props);

		let initialStage;

		for (let stage of STAGE_LIST) {
			if (this.canUseStage(stage, true)) {
				initialStage = stage;
				break;
			}
		}

		if (!initialStage) {
			throw new Error('No possible initial stage');
		}

		this.state = _.extend(
			{
				stage: initialStage,
				giftCheckboxBanner: props.showGiftCheckbox
					? {
							checked: false,
							handleChange: this.handleGiftCheckboxChange
					  }
					: undefined,
				choices: {}
			},
			CheckoutStages.getDerivedStateFromProps(props, {})
		);
	}

	static getDerivedStateFromProps(props: Props, state: State) {
		const { planTypes } = props;

		const choices = _.cloneDeep(
			props.handleSelectPlan ? props.choices : _.defaults(state.choices, props.choices)
		);

		let planId;

		for (const stage of Object.values(STAGE_WITH_CHOICE)) {
			const fixedChoice = CheckoutStages.fixedChoiceFor(planTypes, stage);

			if (fixedChoice) {
				choices[stage] = fixedChoice;
			}
		}

		const planIds = CheckoutStages.getPlanIds(planTypes, choices);

		if (planIds.length === 1) {
			planId = planIds[0];
		}

		return _.merge(
			{},
			state,
			_.omitBy(
				{
					choices,
					planId
				},
				_.isNil
			)
		);
	}

	componentWillUnmount() {
		CK.checkoutStagesMounted = false;
	}

	componentDidMount() {
		CK.checkoutStagesMounted = true;
		const { trackFacebookPixel, trackAdwordsConversion , trackTiktokPixel, trackHotjarPixel} = this.props.appContext.trackers;
		trackFacebookPixel(FACEBOOK_STANDARD_EVENT.INITIATE_CHECKOUT);
		trackTiktokPixel(TIKTOK_STANDARD_EVENT.INITIATE_CHECKOUT);
		trackAdwordsConversion(ADWORDS_CONVERSION_LABEL.INITIATE_CHECKOUT);

		if (CK.moduleContainer.module('IntercomManager')) {
			CK.moduleContainer.module('IntercomManager').hide();
		}

		const { planId } = this.state;
		this.setCouponForSinglePlan(planId);

		
	}

	handleFamilyCheckboxChange = (checked: boolean) => {
		this.setState(prevState => {
			const mergedState = _.merge(prevState, {
				choices: {
					size: checked ? PLAN_SIZE.FAMILY : PLAN_SIZE.INDIVIDUAL
				}
			});

			this.updatePlanIdInNewState(mergedState);

			return mergedState;
		});
	};

	handleGiftCheckboxChange = (checked: boolean) =>
		this.setState(prevState => {
			const planId = prevState.planId;

			let newPlan, newDuration;

			if (planId) {
				if (checked && _.includes(planId, PLAN_DURATION.YEARLY)) {
					newDuration = PLAN_DURATION.YEAR;
					newPlan = planId.replace(PLAN_DURATION.YEARLY, newDuration);
				} else if (!checked && _.includes(planId, PLAN_DURATION.YEAR)) {
					newDuration = PLAN_DURATION.YEARLY;
					newPlan = planId.replace(PLAN_DURATION.YEAR, newDuration);
				}
			}

			if (newPlan) {
				return _.merge(prevState, {
					giftCheckboxBanner: { checked },
					planId: newPlan,
					choices: {
						duration: newDuration
					}
				});
			} else {
				return {
					giftCheckboxBanner: { checked, handleChange: this.handleGiftCheckboxChange }
				};
			}
		});

	// TODO: When we finish react user props this should be a prop
	hasHadAPlan() {
		return CK.user.hasHadAPlan();
	}

	// TODO: When we finish react user props this should be a prop
	hasPassword() {
		return !!CK.user.passwordHash();
	}

	async setCouponForSinglePlan(planId?: string) {
		if (!planId) {
			return;
		}

		const storageManager = StorageManager.mod();
		const affiliate = storageManager ? storageManager.get(storageAffiliateKey) : undefined;

		try {
			const { coupon } = await verifyCouponFromClient({
				code: affiliate,
				currency: this.props.currency,
				planId,
				hasHadAPlan: this.hasHadAPlan()
			});

			this.setState({
				coupon
			});
		} catch (err) {
			CK.logger.info(err);
		}
	}

	handleSelectPlan = (planId: string, coupon: any) => {
		const { trackAnalytic, trackFacebookPixel, trackTiktokPixel, trackHotjarPixel } = this.props.appContext.trackers;

		const duration = subscriptionPlans(planId).durationKey();

		this.setStateAndMove({
			planId,
			coupon,
			choices: _.merge(this.state.choices, {
				duration
			})
		});

		trackAnalytic('SelectPlan', {
			planId
		});

		trackFacebookPixel(FACEBOOK_CUSTOM_EVENT.SELECT_PLAN, {
			planId
		});
	};

	static getPlanIds(planTypes: PlanType[], choices: Choices, omitDuration?: boolean): string[] {
		let planIds = _.map(
			_.reject(
				_.filter(planTypes, omitDuration ? _.omit(choices, 'duration') : choices),
				planType => {
					let excludedBy3MonthTestCohort = CK.fn.inTest('CheaperThreeMonthRecurringPlan')
						? planType.duration === PLAN_DURATION.MONTHLY
						: planType.duration === PLAN_DURATION.THREE_MONTHLY;

					let excludedBy12MonthCreditTestCohort = CK.fn.inTest('12MonthCreditForTests')
						? planType.duration === PLAN_DURATION.YEARLY
						: planType.duration === PLAN_DURATION.YEAR;

					return excludedBy3MonthTestCohort || excludedBy12MonthCreditTestCohort;
				}
			),
			planTypeToPlanId
		);

		return planIds;
	}

	static fixedChoiceFor(planTypes: PlanType[], stage: STAGE) {
		const possibleChoices = _.uniq(_.map(planTypes, stage));

		if (possibleChoices.length === 1) {
			return possibleChoices[0];
		}
	}

	canUseStage(stage: STAGE, navigatingForward?: boolean) {
		return (
			!CheckoutStages.fixedChoiceFor(this.props.planTypes, stage) &&
			(!navigatingForward || (navigatingForward && !this.props.choices[stage]))
		);
	}

	setStateAndMove(newState: Partial<State>, forward = true) {
		const currentStageIndex = STAGE_LIST.indexOf(this.state.stage);

		if (currentStageIndex === -1) {
			throw new Error('currentStageIndex not found');
		}

		if (
			(currentStageIndex === STAGE_LIST.length && forward) ||
			(currentStageIndex === 0 && !forward)
		) {
			throw new Error(`Desired stage index out of range: ${currentStageIndex} ${forward}`);
		}

		let desiredStageIndex = currentStageIndex,
			desiredStage: STAGE;

		do {
			desiredStageIndex += forward ? 1 : -1;
			desiredStage = STAGE_LIST[desiredStageIndex];
		} while (!this.canUseStage(desiredStage, forward));

		if (!this.canUseStage(desiredStage, forward)) {
			return;
		}

		this.setState(prevState => {
			const mergedState = _.merge(
				prevState,
				{
					stage: desiredStage
				},
				newState
			);

			if (desiredStage === STAGE.PAYMENT) {
				this.updatePlanIdInNewState(mergedState);
			}

			return mergedState;
		});
	}

	updatePlanIdInNewState(state: State) {
		state.planId = CheckoutStages.getPlanIds(this.props.planTypes, state.choices)[0];

		if (!state.planId) {
			state.stage = STAGE.DURATION;
		} else {
			this.setCouponForSinglePlan(state.planId);

			if (this.props.handleSelectPlan) {
				this.props.handleSelectPlan(state.planId);
			}
		}
	}

	componentDidUpdate(prevProps: Props, prevState: State) {
		const { planId } = this.state;
		if (planId !== prevState.planId) {
			this.setCouponForSinglePlan(planId);
		}
	}

	handleCurrencyChange = (currency: CURRENCY) => {
		this.props.handleCurrencyChange && this.props.handleCurrencyChange(currency);
	};

	saveConversionFeedback(request: Object) {
		return CK.clientSockets.users.emit('saveConversionFeedback', request);
	}

	updatePassword(password: string) {
		return CK.clientSockets.users.emit('updateAccountDetails', {
			password
		});
	}

	navigate(href: string) {
		Frame.mod().navigate(href);
	}

	confirmationStage(accountLink: string) {
		const { trackAnalytic } = this.props.appContext.trackers;


		try {

			if (CK.isCoolMath() === true) {
				gtag('event', 'conversion', {
					'send_to': 'AW-386269532/-_PkCMDT4IoDENyCmLgB',
					'value': 0.0,
					'currency': 'USD',
					'transaction_id': ''
			  });
			}
		
		} catch(err) {

			console.log(err);

		}

		const feedbackOptions = _.omitBy(conversionFeedbackOptions, option => option.disabled);

		const FREEFORM = 'freeform';

		const feedbackElements = [
			<p key="whichFeatures">Why did you purchase?</p>,
			..._.map(feedbackOptions, (value, key) => {
				return <CheckboxInput optional={true} label={value.label} name={key} key={key} />;
			}),
			<p key="anythingElse">{`Anything else you'd like to tell us? We'd love to hear your feedback!`}</p>,
			<TextAreaInput
				optional={true}
				key={FREEFORM}
				name={FREEFORM}
				placeholder={`What's on your mind?`}
			/>
		];

		const hasPassword = this.hasPassword();

		const submitFeedback = async (data: any) => {
			const request = {
				planId: this.state.planId,
				purchaseId: this.state.purchaseId,
				hadAPlan: this.state.hadAPlan,
				feedback: _.zipObject(
					_.keys(feedbackOptions),
					_.map(feedbackOptions, (value, key) => {
						return data[key];
					})
				),
				[FREEFORM]: data[FREEFORM],
				hasPassword
			};

			return this.saveConversionFeedback(request);
		};

		if (hasPassword) {
			return (
				<div className="CheckoutStages__inner-maxWidthWrapper">
					<div className="CheckoutStages__confirmationWrapper-title">
						{lang.SUCCESS.hadPassword.title}
					</div>
					<Form
						className="CheckoutStages__feedback"
						handleSubmit={async (data: any) => {
							try {
								await submitFeedback(data);
							} catch (err) {
								CK.logger.error(err);
							}

							this.navigate(accountLink);
						}}
						buttonText="Go to My Account"
					>
						{feedbackElements}
					</Form>
				</div>
			);
		} else {
			let skipped = false;

			

			return (
				<div className="CheckoutStages__inner-maxWidthWrapper">
					<div className="CheckoutStages__confirmationWrapper-title">
						{lang.SUCCESS.setupPassword.title}
					</div>
					<p className="CheckoutStages__topMessage">
						{lang.SUCCESS.setupPassword.canSetupPassword}
					</p>
					<p className="CheckoutStages__topMessage">{lang.SUCCESS.setupPassword.canSkip}</p>
					<Form
						className="CheckoutStages__feedback"
						ref={(component: Form) => (this.feedbackForm = component)}
						handleSubmit={async (data: any) => {
							trackAnalytic('PaymentConfirmationSetPassword');

							try {
								await Promise.all([
									!skipped && this.updatePassword(data.password),
									submitFeedback(data)
								]);
							} catch (err) {
								CK.logger.error(err);
							}

							this.navigate(accountLink);
						}}
						buttonText="Set Password and Go to My Account"
					>
						<TextInput
							label="Password"
							name="password"
							type="password"
							validate={new PasswordVerifier()}
						/>
						{feedbackElements}
					</Form>

					<RoundButton
						buttonClass="skip"
						text="Skip for now"
						size="tiny"
						colour="yellow"
						handleClick={async () => {
							trackAnalytic('PaymentConfirmationSkipSetPassword');

							try {
								skipped = true;
								await this.feedbackForm.handleSubmit();
							} catch (err) {
								CK.logger.error(err);
							}
						}}
					/>
				</div>
			);
		}
	}

	getBillingMethod(isExistingCustomer: boolean) {
		if (isExistingCustomer) {
			if (CK.user.externalBilling() === CK.const.EXTERNAL_BILLING_SOURCE.BRAINTREE) {
				return BILLING_METHOD.BRAINTREE;
			} else {
				return BILLING_METHOD.STRIPE;
			}
		} else {
			return null;
		}
	}

	paymentSummaryProps(): PaymentSummaryProps {
		const user = CK.user;
		const { currency, currentPlanType, showGuaranteesBanner } = this.props;
		const { planId, giftCheckboxBanner, choices, coupon } = this.state;
		const giftSelected = giftCheckboxBanner && giftCheckboxBanner.checked;
		const { size, product } = choices;

		const plan = subscriptionPlans(planId);

		const priceInCurrencyOptions = {
			coupon,
			user
		};

		const nextPlanStartDate = plan.getStartDate(CK.user) as Date;

		let priceInCurrency, individualPriceInCurrency, familyPriceInCurrency;

		if (plan.family()) {
			const individualPlan = subscriptionPlans(plan.id().replace('-family', ''));

			individualPriceInCurrency = individualPlan.priceInCurrency(currency, priceInCurrencyOptions);

			priceInCurrency = familyPriceInCurrency = plan.priceInCurrency(
				currency,
				priceInCurrencyOptions
			);
		} else {
			const familyPlan = subscriptionPlans(plan.id() + '-family');

			familyPriceInCurrency = familyPlan.priceInCurrency(currency, priceInCurrencyOptions);

			priceInCurrency = individualPriceInCurrency = plan.priceInCurrency(
				currency,
				priceInCurrencyOptions
			);
		}

		let endDate, nextPaymentDate;

		if (!plan.lifetime() && (!giftSelected || !plan.oneOff())) {
			if (plan.oneOff()) {
				endDate = plan.endDate(nextPlanStartDate);
			} else {
				nextPaymentDate = plan.endDate(nextPlanStartDate);
			}
		}

		const startDate =
			!plan.lifetime() && giftSelected && plan.oneOff() ? WHEN_REDEEMED : nextPlanStartDate;

		const currentPlanDuration = _.get(currentPlanType, 'duration');

		const moneyBackGuarantee = plan.moneyBackGuaranteeMessage({
			user,
			startDate: nextPlanStartDate,
			asGift: giftSelected
		});

		const isSubscriptionChange =
			plan &&
			isRecurringPlanDuration(plan.durationKey()) &&
			currentPlanDuration &&
			isRecurringPlanDuration(currentPlanDuration);

		const paymentDate =
			plan && plan.oneOff() ? new Date() : CK.user.getNextInvoiceDate() || new Date();

		if (isSubscriptionChange) {
			nextPaymentDate = paymentDate;
		}

		const intervalDescription = plan ? plan.formattedIntervalTitle() : null;

		const individualFullPrice = new MonetaryValue(individualPriceInCurrency.fullPrice, currency);

		const familyUpgradePrice = new MonetaryValue(
			familyPriceInCurrency.fullPrice - individualFullPrice.value,
			currency
		);

		return {
			choices,
			individualFullPrice,
			familyUpgradePrice,
			totalPrice: new MonetaryValue(priceInCurrency.price, currency),
			upgradeDiscount: priceInCurrency.upgradeDiscount
				? new MonetaryValue(priceInCurrency.upgradeDiscount, currency)
				: undefined,
			isSubscriptionChange,
			intervalDescription,
			moneyBackGuarantee: showGuaranteesBanner ? undefined : moneyBackGuarantee,
			size,
			product: PRODUCTS[product],
			paymentDate,
			startDate,
			endDate,
			nextPaymentDate,
			showCancelAnytime: plan.interval() === 'month',
			coupon: coupon
				? {
						name: coupon.name(),
						discount: new MonetaryValue(priceInCurrency.couponDiscount, currency)
				  }
				: undefined
		};
	}

	render() {
		const { trackAnalytic, trackFacebookPixel, trackTiktokPixel, trackHotjarPixel } = this.props.appContext.trackers;
		const isExistingCustomer = CK.user.stripeCustomerId() ? true : false;

		const { theme = CHECKOUT_THEME.SIDEBAR, showGuaranteesBanner } = this.props;

		if (CK.user && CK.user.linkedTo()) {
			return (
				<div style={{ maxWidth: '60rem', margin: '0 auto', textAlign: 'center' }}>
					<div>
						Please go to your &nbsp;<a href="/account/?panel=plan">account page</a>&nbsp; and switch
						to the billing user to use the checkout.
					</div>
					<div>
						<RoundButton
							text={'Account Page'}
							handleClick={() => (window.location.href = '/account/?panel=plan')}
						/>
					</div>
				</div>
			);
		}

		let session;
		const userManager = UserManager.mod();
		if (userManager) {
			userManager.getSession();
		}
		const autoRegistered = _.get(session, 'autoRegistered');

		const { currency, allowStageNavigation, showFamilyCheckbox } = this.props;
		const { stage, planId, giftCheckboxBanner, coupon } = this.state;
		const giftSelected = giftCheckboxBanner && giftCheckboxBanner.checked;

		let inner, plan;

		if (planId) {
			plan = subscriptionPlans(planId);
		}

		let sidebarIndex = 1;

		const createSidebarChoice = (options: any) => {
			const { name, description, classes, handleClick, disabled, buttonHidden } = options;

			return (
				<div className={classnames('CheckoutStages__sidebar-choiceWrapper', classes)}>
					<div className="choice">
						<div className="index">{sidebarIndex++}</div>
						<div className="leftKey">{name}</div>
						{!buttonHidden && (
							<RoundButton
								handleClick={handleClick}
								size="tiny"
								colour="yellow"
								className="rightResult"
								disabled={disabled}
								text={description}
							/>
						)}
					</div>
				</div>
			);
		};

		const addSidebarChoice = (name: string, sidebarStage: STAGE, descriptor?: any) => {
			if (!allowStageNavigation) {
				return null;
			}

			const handleClick = () => {
				if (this.canUseStage(sidebarStage)) {
					this.setState({
						stage: sidebarStage
					});
				}
			};

			const isCurrentStage = STAGE_LIST.indexOf(sidebarStage) === STAGE_LIST.indexOf(stage);

			const choice =
				sidebarStage === STAGE.DURATION ? this.state.planId : this.state.choices[sidebarStage];

			const isConfirmation = stage === STAGE.CONFIRMATION;

			const classes = classnames(sidebarStage, isCurrentStage && 'current');

			const description = (descriptor && _.get(descriptor(choice), 'name')) || choice;

			const buttonDisabled =
				isConfirmation || !!CheckoutStages.fixedChoiceFor(this.props.planTypes, sidebarStage);

			return createSidebarChoice({
				classes,
				description,
				name,
				handleClick,
				disabled: buttonDisabled,
				buttonHidden:
					isConfirmation ||
					(STAGE_LIST.indexOf(sidebarStage) >= STAGE_LIST.indexOf(stage) && !choice)
			});
		};

		const productDescriptor = (product: Product | PRODUCT_ID) => {
			if (typeof product === 'string') {
				product = PRODUCTS[product];
			}
			if (!product) {
				return;
			}
			return {
				id: product.id,
				name: product.name,
				image: <img src={PRODUCT_IMAGES[product.id]} />
			};
		};

		const sizeDescriptor = (size: PLAN_SIZE) => {
			const text = lang.SIZE_DESCRIPTIONS[size];

			if (!text) {
				return;
			}

			const description = langToReactElements(text);

			return {
				name: _.upperFirst(size),
				description,
				image: <img src={SIZE_IMAGES[size]} />
			};
		};

		let paymentSummaryProps: PaymentSummaryProps;

		if (stage === STAGE.PAYMENT) {
			paymentSummaryProps = this.paymentSummaryProps();
		}

		const sidebar = (
			<div className="CheckoutStages__sidebar">
				<div className="CheckoutStages__sidebar-header">Checkout</div>
				{addSidebarChoice('Product', STAGE.PRODUCT, productDescriptor)}
				{addSidebarChoice('Plan size', STAGE.SIZE, sizeDescriptor)}
				{addSidebarChoice('Duration', STAGE.DURATION, (planId: string) => {
					if (!planId) {
						return;
					}
					const plan = subscriptionPlans(planId);
					return { name: `${plan.formattedIntervalTitle()}` };
				})}
				{addSidebarChoice('Payment', STAGE.PAYMENT)}
				{addSidebarChoice('Confirmation', STAGE.CONFIRMATION)}

				{stage === STAGE.PAYMENT && (
					<DesktopPaymentSummary
						summary={paymentSummaryProps}
						giftCheckboxBanner={giftCheckboxBanner}
						familyCheckboxBanner={
							showFamilyCheckbox
								? {
										checked: this.state.choices.size === PLAN_SIZE.FAMILY,
										handleChange: this.handleFamilyCheckboxChange
								  }
								: undefined
						}
					/>
				)}

				{showGuaranteesBanner && paymentSummaryProps && (
					<GuaranteesBanner
						isLifetime={plan.lifetime()}
						showCancelAnytime={paymentSummaryProps.showCancelAnytime}
						startDate={paymentSummaryProps.startDate}
					/>
				)}


					<div className="CheckoutStages__trustpilot">
						
							<div className="scoreName">Excellent</div>
							<ReactCKImage name="trustpilot-stars" forceImgTag={true} extraClasses={['stars']} />
							<div>
								<a href="https://uk.trustpilot.com/review/codekingdoms.com">
									<div className="summary">See all our reviews on </div>{' '}
									<ReactCKImage
										name="trustpilot-score"
										forceImgTag={true}
										extraClasses={['logo']}
									/>
								</a>
							</div>

				</div>

				<div className="CheckoutStages__banner">
					<HereToHelp
						openIntercom={() => {
							IntercomManager.mod().open();
							IntercomManager.mod().show();
						}}
					/>
				</div>

				{stage === STAGE.CONFIRMATION && (
					<div className="CheckoutStages__confirmationWrapper">
						<img src={checkoutConfirmationTick} />
						<div className="CheckoutStages__confirmationWrapper-title">{lang.SUCCESS.title}</div>
						<p>{lang.SUCCESS.message}</p>
						<p className="CheckoutStages__confirmationWrapper-successEmail">
							{Language.mapVariables(lang.SUCCESS.email, {
								email: this.state.paymentEmail
							})}
						</p>
					</div>
				)}
			</div>
		);

		const choiceTiles = (key: string, choices: any, descriptor: any) => (
			<TileChoices
				handleClick={(id: any) => {
					const stateUpdate = {
						choices: {
							[key]: id
						}
					};

					if (key === STAGE.SIZE) {
						trackAnalytic('SelectPlanSize', {
							id
						});

						trackFacebookPixel(FACEBOOK_CUSTOM_EVENT.SELECT_PLAN_SIZE, {
							id
						});
					}

					this.setStateAndMove(stateUpdate);
				}}
			>
				{_.map(choices, choice => (
					<TileChoice className={key} id={choice} key={choice} {...descriptor(choice)} />
				))}
			</TileChoices>
		);

		let accountLink;

		if (this.state.paymentEmail) {
			accountLink =
				'/account/' +
				CK.fn.createQueryString({
					message: `Thanks for your purchase - we've sent you an email invoice to ${this.state.paymentEmail} which contains a link to get to this page.\n\nYou can change your password on the Details panel.`
				});
		} else {
			accountLink = '/account/';
		}

		switch (stage) {
			case STAGE.PRODUCT:
				inner = (
					<div>
						<div className="CheckoutStages__inner-title">Which game do you want to code?</div>
						{choiceTiles(
							'product',
							_.pickBy(PRODUCTS, product => _.some(this.props.planTypes, { product: product.id })),
							productDescriptor
						)}
					</div>
				);
				break;

			case STAGE.SIZE:
				inner = (
					<div>
						<div className="CheckoutStages__inner-title">How many users will you need?</div>
						{choiceTiles('size', PLAN_SIZE, sizeDescriptor)}
					</div>
				);
				break;

			case STAGE.DURATION:
				inner = (
					<div>
						<VanillaPaymentPlans
							currency={this.props.currency}
							planIds={CheckoutStages.getPlanIds(this.props.planTypes, this.state.choices, true)}
							handleSelectPlan={this.handleSelectPlan}
							isOnCheckoutPage={true}
						/>
					</div>
				);
				break;

			case STAGE.PAYMENT: {
				const hadAPlan = this.hasHadAPlan();

				const { paymentDate, isSubscriptionChange } = paymentSummaryProps;
				let changeSubscriptionMessage = '';

				if (isSubscriptionChange) {
					const currentSub = CK.user.getCurrentSubscription();

					let amount;

					const priceInCurrencyArgs = [
						currency,
						{
							coupon,
							html: false,
							user: CK.user
						}
					];

					if (currentSub) {
						const oldPlan = subscriptionPlans(currentSub.planId());

						amount = oldPlan.priceInCurrency(...priceInCurrencyArgs).formatted;

						changeSubscriptionMessage = Language.mapVariables(lang.CHANGE_SUBSCRIPTION_MESSAGE, {
							oldAmount: amount,
							oldInterval: oldPlan.formattedInterval(true),
							newInterval: plan.formattedInterval(true),
							paymentDate: format(paymentDate, FRIENDLY),
							newAmount: plan.priceInCurrency(...priceInCurrencyArgs).formatted
						});
					}
				}

				const billingMethod = this.getBillingMethod(isExistingCustomer);

				inner = (
					<div className="CheckoutStages__inner-maxWidthWrapper">
						<div className="CheckoutStages__inner-title">Payment Details</div>
						<ConnectedPaymentForm
							handleCurrencyChange={this.handleCurrencyChange}
							changeSubscriptionMessage={changeSubscriptionMessage}
							paymentDate={paymentDate}
							hasHadAPlan={this.hasHadAPlan()}
							giftSelected={giftSelected}
							planId={planId}
							allowCurrencyChange={!CK.user.paymentCurrency()}
							currency={currency}
							coupon={
								this.state.coupon &&
								plan &&
								plan.isCouponApplicable(this.state.coupon, this.props.currency)
									? this.state.coupon
									: null
							}
							autoRegisteredSession={autoRegistered ? session : null}
							handleSubmit={(result: any, request: any) =>
								this.setStateAndMove({
									paymentEmail: request.email,
									purchaseId: result.purchaseId,
									hadAPlan
								})
							}
							billingMethod={billingMethod}
							validCardExpected={CK.user.validCardExpected()}
							email={CK.user.paymentEmail() || CK.user.email()}
						/>
					</div>
				);
				break;
			}
			case STAGE.CONFIRMATION:
				inner = this.confirmationStage(accountLink);
				break;
		}

		const canUsePreviousStage =
			stage !== STAGE_LIST[0] &&
			this.canUseStage(STAGE_LIST[STAGE_LIST.indexOf(this.state.stage) - 1]);

		return (
			<div className={classnames('CheckoutStages', 'CheckoutStages--theme-' + theme)}>
				{allowStageNavigation && (
					<div className="CheckoutStages__navigation-bar">
						<div className="CheckoutStages__navigation-text">
							<RoundButton
								buttonClass="backButton"
								handleClick={() => this.setStateAndMove({}, false)}
								text="Back"
								colour="yellow"
								size="tiny"
								disabled={this.state.stage === 'product' || this.state.stage === 'confirmation'}
							/>
						</div>
						<div className="CheckoutStages__navigation-text">
							<ProgressIndicator
								disabled
								steps={['product', 'size', 'plan', 'payment', 'confirmation']}
								index={STAGE_LIST.indexOf(this.state.stage)}
								linear
							/>
						</div>
					</div>
				)}
				<div className="CheckoutStages__inner">
					{allowStageNavigation && stage !== STAGE.CONFIRMATION && canUsePreviousStage ? (
						<RoundButton
							buttonClass="CheckoutStages__navigation-back-button"
							handleClick={() => this.setStateAndMove({}, false)}
							text="Back"
							colour="yellow"
							size="small"
						/>
					) : null}
					{inner}
				</div>
				{sidebar}
				{stage === STAGE.PAYMENT && <MobilePaymentSummary summary={paymentSummaryProps} />}
			</div>
		);
	}
}

export const ConnectedCheckoutStages = WithCurrency(withAppContext(CheckoutStages));
